import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <section className="hero-section">
        <video
          className="hero-video"
          src={`${process.env.PUBLIC_URL}/herovideo.mp4`}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={`${process.env.PUBLIC_URL}/herovideo.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Transform 365 Business Solutions</h1>
            <h2>Digital Transformation — Done Once, Done Right!</h2>
            <p>
              We deliver specialized solutions using Microsoft Dynamics 365, Power Platform, Azure, and Power Pages—built for real-world business needs.
            </p>
            <div className="cta-buttons">
              <Link to="/services" className="cta-btn" aria-label="Explore our services">
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="consult-highlight">
        <h2>Book Your Free Consultation</h2>
        <p>
          Not sure where to start? We offer a 5-hour <strong>Free Assessment Package</strong> to review your current systems and provide a tailored roadmap for your digital transformation.
        </p>
        <Link to="/contact" className="consult-btn" aria-label="Book your free consultation">
          Book Your Free Consultation
        </Link>
      </section>
    </div>
  );
};

export default Home;
